import { Button, Card, Select, Space, Typography } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useState, useEffect } from "react";
import { hostname } from "../hooks/useEndeavour";

const { Text } = Typography;

export default function RulesSelector({ value, onChange }) {
  const [groups, setGroups] = useState([]);

  const rulesQuery = useQuery({
    queryKey: ["campaign_rules"],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/campaign/rule`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => res.data.payload.data || []);
    },
  });

  const ruleOptions = rulesQuery.data?.map((rule) => ({
    value: rule.id,
    label: `${rule.name} (${rule.type})`,
  }));

  useEffect(() => {
    if (value && Array.isArray(value) && value.length > 0) {
      if (value.some((item) => Array.isArray(item))) {
        const convertedGroups = value.map((group) => (Array.isArray(group) ? group : [group]));
        setGroups(convertedGroups);
      } else {
        const convertedGroups = value.map((ruleId) => [ruleId]);
        setGroups(convertedGroups);
      }
    } else if (!value || value.length === 0) {
      setGroups([]);
    }
  }, [value]);

  const emitChange = (newGroups) => {
    const filteredGroups = newGroups
      .map((group) => group.filter((id) => id !== null && id !== undefined))
      .filter((group) => group.length > 0);

    if (filteredGroups.length === 0) {
      onChange([]);
      return;
    }

    const allSingleRule = filteredGroups.every((group) => group.length === 1);
    if (allSingleRule) {
      const flatArray = filteredGroups.flat();
      onChange(flatArray);
    } else {
      onChange(filteredGroups);
    }
  };

  const addGroup = () => {
    const newGroups = [...groups, [null]];
    setGroups(newGroups);
  };

  const removeGroup = (groupIndex) => {
    const newGroups = groups.filter((_, index) => index !== groupIndex);
    setGroups(newGroups);
    emitChange(newGroups);
  };

  const addRuleToGroup = (groupIndex) => {
    const newGroups = [...groups];
    if (!newGroups[groupIndex]) {
      newGroups[groupIndex] = [];
    }
    newGroups[groupIndex] = [...newGroups[groupIndex], null];
    setGroups(newGroups);
  };

  const updateRuleInGroup = (groupIndex, ruleIndex, ruleId) => {
    const newGroups = [...groups];
    if (!newGroups[groupIndex]) {
      newGroups[groupIndex] = [];
    }
    newGroups[groupIndex][ruleIndex] = ruleId;
    setGroups(newGroups);
    emitChange(newGroups);
  };

  const removeRuleFromGroup = (groupIndex, ruleIndex) => {
    const newGroups = [...groups];
    newGroups[groupIndex] = newGroups[groupIndex].filter((_, index) => index !== ruleIndex);
    if (newGroups[groupIndex].length === 0) {
      newGroups.splice(groupIndex, 1);
    }
    setGroups(newGroups);
    emitChange(newGroups);
  };

  return (
    <div>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Space>
          <Button size="small" onClick={addGroup}>
            <PlusOutlined /> Add Rule
          </Button>
        </Space>

        {groups.map((group, groupIndex) => (
          <Card
            key={groupIndex}
            size="small"
            title={
              <Space>
                <Text strong>Rule Group {groupIndex + 1}</Text>
                {group && group.filter((id) => id !== null).length > 1 && <Text type="secondary">(ALL must match)</Text>}
              </Space>
            }
            extra={
              <Button size="small" danger onClick={() => removeGroup(groupIndex)}>
                <DeleteOutlined />
              </Button>
            }
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              {group &&
                group.map((ruleId, ruleIndex) => (
                  <Space key={ruleIndex}>
                    <Select
                      style={{ width: 250 }}
                      placeholder="Select rule"
                      value={ruleId}
                      onChange={(val) => updateRuleInGroup(groupIndex, ruleIndex, val)}
                      options={ruleOptions}
                      allowClear
                    />
                    {group.filter((id) => id !== null).length > 1 && (
                      <Button size="small" danger onClick={() => removeRuleFromGroup(groupIndex, ruleIndex)}>
                        <DeleteOutlined />
                      </Button>
                    )}
                  </Space>
                ))}
              <Button size="small" type="dashed" onClick={() => addRuleToGroup(groupIndex)} icon={<PlusOutlined />}>
                Add AND Condition
              </Button>
            </Space>
          </Card>
        ))}

        {groups.length > 1 && <Text type="secondary">Groups are combined with OR logic (any group must match)</Text>}
      </Space>
    </div>
  );
}